import classnames from 'classnames/bind';
import style from './empty.module.scss';

const cx = classnames.bind(style);

const InterviewPracticeQuestionSelectBodyMyselfEmpty = () => {
  return (
    <div className={cx('emptyWrap')}>
      <div className={cx('textWrap')}>
        <div className={cx('title')}>질문을 만들어 보세요.</div>
        <div className={cx('description')}>
          질문을 입력하고 추가하기 버튼을
          <br />
          누르시면 질문이 만들어져요.
        </div>
      </div>
    </div>
  );
};

export default InterviewPracticeQuestionSelectBodyMyselfEmpty;
